import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reg-eximdemo',
  templateUrl: './reg-eximdemo.component.html',
  styleUrls: ['./reg-eximdemo.component.scss']
})
export class RegEXIMdemoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
